"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const RN = __importStar(require("react-native"));
function getTrackStyle(length, thickness, color, vertical) {
    return RN.StyleSheet.create({
        thumb: {
            flexGrow: length,
            flexBasis: 0,
            borderRadius: thickness / 2,
            backgroundColor: color,
            // This is for web
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...(RN.Platform.OS === 'web' ? { userSelect: 'none' } : {}),
            [vertical ? 'width' : 'height']: thickness
        }
    }).thumb;
}
const Track = ({ style, thickness, length, vertical, color = 'grey' }) => {
    const trackViewStyle = react_1.default.useMemo(() => [
        getTrackStyle(length, thickness, color, vertical), style
    ], [length, thickness, color, vertical, style]);
    return react_1.default.createElement(RN.View, { style: trackViewStyle });
};
exports.default = react_1.default.memo(Track);
